import type { FieldValidation } from './fieldValidation';

export const isValidEmail = (value: string) =>
  /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);

export const emailValidation: FieldValidation = {
  // An empty field is treated as not-yet-filled rather than invalid, so the
  // "invalid email" error never shows on a blank input. Submit is still gated
  // by isValidEmail, which stays strict and rejects empty.
  validateInput: (value) => value === '' || isValidEmail(value),
  errorMessage: () => 'Please enter a valid email address',
};
